import Vue from 'vue'

export const actions = {
  async loginGoogle ({ commit }, payload) {
    await this.$auth.setStrategy('local')
    try {
      const response = await this.$axios.post('/auth/oauth/google', payload)
      await this.$auth.setUserToken(response.data.access_token, response.data.expires_in)
    } catch (error) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: error.response ? error.response.data.error : ''
        })
      }
    }
  },
  async loginFacebook ({ commit }, payload) {
    await this.$auth.setStrategy('local')
    try {
      const response = await this.$axios.post('/auth/oauth/facebook', payload)
      await this.$auth.setUserToken(response.data.access_token, response.data.expires_in)
    } catch (error) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: error.response ? error.response.data.error : ''
        })
      }
    }
  }
}
